import { LOINCCodes } from "@/fhir/enums/loinc";
import { Questionnaires } from "@/fhir/enums/questionnaires";
import { QuiltedHealthCodes, QuiltedHealthValueSets } from "@/fhir/enums/quilted-health";

export enum TransferOfCareQuestionnaireURLs {
  TransferOfCare = Questionnaires.TransferOfCare,
  ClientInformation = Questionnaires.TransferOfCareClientInformation,
  TransferProvider = Questionnaires.TransferOfCareTransferProvider,
  ReceivingProvider = Questionnaires.TransferOfCareReceivingProvider,
  TransferDetails = Questionnaires.TransferOfCareTransferDetails,
}

/** Display copy for the {@link TransferOfCareEncounterLinkId.ClinicalJustification} field. */
export const REASON_FOR_TRANSFER_LABEL = "Reason for Transfer";

/** Validation copy for the {@link TransferOfCareEncounterLinkId.ClinicalJustification} field. */
export const REASON_FOR_TRANSFER_REQUIRED_MESSAGE = "Reason for transfer is required";

export enum TransferOfCareEncounterLinkId {
  EncounterNotes = "encounterNotes",
  EncounterTemplate = "encounterTemplate",
  /**
   * Persisted linkId, kept stable so answers in signed and locked QuestionnaireResponses stay
   * readable. The field is labelled with {@link REASON_FOR_TRANSFER_LABEL}.
   */
  ClinicalJustification = "clinicalJustification",
  EncounterLocation = "encounterLocation",
  EncounterStartDate = "encounterStartDate",
  EncounterStartDateTimezone = "encounterStartDateTimezone",
  EncounterAmendmentInfoReason = "encounterAmendmentInfoReason",
  EncounterAmendmentInfoSpecify = "encounterAmendmentInfoSpecify",
  EncounterAmendmentInfoNotes = "encounterAmendmentInfoNotes",
  EncounterAmendmentInfoNotifyClient = "encounterAmendmentInfoNotifyClient",
}

export enum TransferOfCareTransferProviderQuestionsLinkIds {
  PracticeName = "practiceName",
  NameAndCredentials = "nameAndCredentials",
  Address = "address",
  TelephoneNumber = "telephoneNumber",
  FaxNumber = "faxNumber",
  EmailAddress = "emailAddress",
}

export enum TransferOfCareTransferDetailsQuestionsLinkIds {
  date = "date",
  time = "time",
  notes = "notes",
  transferType = "transferType",
  reasons = "reasons",
  urgency = "urgency",
  condition = "condition",
  transferMode = "transferMode",
  midwifeStayWithClient = "midwifeStayWithClient",
  epiduralAfterTransfer = "epiduralAfterTransfer",
  oxytocinForLaborAfterTransfer = "oxytocinForLaborAfterTransfer",
  decisionDate = "decisionDate",
  decisionTime = "decisionTime",
  departureDate = "departureDate",
  departureTime = "departureTime",
  arrivalDate = "arrivalDate",
  arrivalTime = "arrivalTime",
}

export enum TransferOfCareReceivingProviderQuestionsLinkIds {
  PracticeName = "practiceName",
  NameAndCredentials = "nameAndCredentials",
  Address = "address",
  TelephoneNumber = "telephoneNumber",
  FaxNumber = "faxNumber",
  EmailAddress = "emailAddress",
}

export enum TransferOfCareClientInformationQuestionsLinkIds {
  FirstName = "firstName",
  LastName = "lastName",
  DateOfBirth = "dateOfBirth",
  Address = "address",
  TelephoneNumber = "telephoneNumber",
  EmailAddress = "emailAddress",
  Insurance = "insurance",
  ResponsibleParty = "responsibleParty",
}

export enum TransferOfCareEncounterDrawerActions {
  Save = "save",
  SignAndLock = "signAndLock",
}

export enum TransferDetailsTypeReasonsCodes {
  Antepartum = LOINCCodes.Antepartum,
  Postpartum = LOINCCodes.Postpartum,
  Newborn = LOINCCodes.Newborn,
  Intrapartum = QuiltedHealthCodes.Intrapartum,
  ImmediatePostpartum = QuiltedHealthCodes.ImmediatePostpartum,
  ImmediateNewborn = QuiltedHealthCodes.ImmediateNewborn,
}

export const TransferDetailsTypeReasonsValueSet = {
  [TransferDetailsTypeReasonsCodes.Antepartum]:
    QuiltedHealthValueSets.TransferDetailsTypeAntepartumOptions,
  [TransferDetailsTypeReasonsCodes.Intrapartum]:
    QuiltedHealthValueSets.TransferDetailsTypeIntrapartumOptions,
  [TransferDetailsTypeReasonsCodes.ImmediatePostpartum]:
    QuiltedHealthValueSets.ImmediatePostpartumTransferTypeOptions,
  [TransferDetailsTypeReasonsCodes.ImmediateNewborn]:
    QuiltedHealthValueSets.ImmediateNewbornTransferTypeOptions,
  [TransferDetailsTypeReasonsCodes.Newborn]: QuiltedHealthValueSets.NewbornTransferTypeOptions,
  [TransferDetailsTypeReasonsCodes.Postpartum]:
    QuiltedHealthValueSets.PostpartumTransferTypeOptions,
};

export const TRANSFER_TYPE_ALLOWED_EXTRA_FIELDS_CODES = [
  TransferDetailsTypeReasonsCodes.Intrapartum,
  TransferDetailsTypeReasonsCodes.ImmediateNewborn,
  TransferDetailsTypeReasonsCodes.ImmediatePostpartum,
];
